<template>
<svg viewBox="0 0 12 12">
<path fill="currentColor" d="M11.561,3.439l-8.26,8.26l-2.676,0.297c-0.358,0.04-0.661-0.263-0.621-0.621l0.297-2.676l8.26-8.26
	c0.586-0.586,1.536-0.586,2.121,0l0.879,0.879C12.146,1.904,12.146,2.854,11.561,3.439z M3.422,10.517V9.703H2.297V8.578H1.483
	L1.017,9.043l-0.154,1.383l0.71,0.71l1.383-0.154L3.422,10.517z M7.39,2.67L2.139,7.922h0.814v1.125h1.125v0.814L9.329,4.61
	L7.39,2.67z M11.03,1.848L10.152,0.97c-0.293-0.293-0.768-0.293-1.061,0L7.92,2.14L9.86,4.079l1.171-1.17
	C11.323,2.616,11.323,2.141,11.03,1.848z"/>
</svg>
</template>
